"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const currencies_json_1 = __importDefault(require("@packages/data/currencies.json"));
const roundToCurrencyDecimals = (value, currencyCode) => {
    const currency = currencyCode ? currencies_json_1.default[currencyCode] : null;
    return value.toFixed(currency?.decimals ?? 2);
};
exports.default = roundToCurrencyDecimals;
